<div class="flex flex-col gap-4">
  <ui-card>
    <div class="flex justify-between items-center">
      <div class="flex items-center gap-2">
        <ui-button
          [routerLink]="['/assignments']"
          [icon]="'arrow-back'"
          [variant]="'ghost'"
        ></ui-button>
        <h1>{{ assignment()?.number }} - {{ assignment()?.wmo_reference }}</h1>
      </div>

      @if (hasRequest()) {
        <ui-button [icon]="'requests'" (click)="goToRequest()">Ga naar aanvraag</ui-button>
      }
    </div>
  </ui-card>

  <div class="grid grid-cols-1 lg:grid-cols-[1fr_400px] gap-4" style="height: calc(100vh - 200px);">
    <!-- Left Column -->
    <div class="flex flex-col gap-4">
      <!-- Customer Info Card -->
      <ui-card class="" [title]="'Klant'" [loading]="loadingDetails()">
        <div class="grid grid-cols-[120px_1fr] gap-y-3 text-sm">
          <span class="text-gray-600">Klantnummer:</span>
          <span class="font-medium">{{
            assignment()?.details?.customer_number
          }}</span>

          <span class="text-gray-600">Naam:</span>
          <span class="font-medium">{{ contactDisplayName() }}</span>

          <span class="text-gray-600">Adres:</span>
          <span class="font-medium">
            {{ assignment()?.details?.address_street }}
            {{ assignment()?.details?.address_house_number }}
            {{ assignment()?.details?.address_house_number_addition }},
            {{ assignment()?.details?.address_zipcode }}
            {{ assignment()?.details?.address_city }}
          </span>

          <span class="text-gray-600">Telefoon:</span>
          <span class="font-medium">{{
            assignment()?.details?.contactperson_phone
          }}</span>

          <span class="text-gray-600">Email:</span>
          <span class="font-medium">{{
            assignment()?.details?.contactperson_email
          }}</span>
        </div>
      </ui-card>

      <!-- Montage Component -->
      <app-assignments-montage
        [assignment]="assignment()"
      ></app-assignments-montage>

      <!-- Service Component -->
      <app-assignments-service
        [assignment]="assignment()"
      ></app-assignments-service>

      <!-- Invoices Component -->
      <ui-card [title]="'Facturen'" [loading]="loadingInvoices()">
        @for (item of invoices(); track item.number) {
        <div
          class="flex items-center justify-between p-3 hover:bg-gray-50 rounded transition-colors group"
        >
          <div class="flex items-center gap-3">
            <ui-icon [name]="'file-pdf'" [color]="'secondary'"></ui-icon>
            <div>
              <div class="text-sm font-medium">{{ item.number }}</div>
              <div class="text-xs text-gray-500">
                {{ item.date | date : "dd-MM-yyyy" }}
              </div>
            </div>
          </div>

          <div class="flex items-center gap-3">
            <!-- Amount -->
            <span class="px-3 py-1 text-xs rounded-full">
              {{ item.amount | currency : "EUR" }}
            </span>

            <!-- Download button - only show if subject_id exists -->
            @if (item.subject_id) {
            <button
              (click)="downloadInvoice(item)"
              class="p-2 text-gray-500 hover:text-blue-600 transition-colors"
              title="Download factuur"
            >
              <ui-icon [name]="'download'" class="w-5 h-5"></ui-icon>
            </button>
            }
          </div>
        </div>
        }
      </ui-card>

      <!-- Complaints Component -->
      <app-assignments-complaints
        [assignment]="assignment()"
      ></app-assignments-complaints>

    </div>

    <!-- Timeline Card -->
   <app-assignments-timeline
      [assignment]="assignment()"
    ></app-assignments-timeline>
  </div>
</div>
